// Expert Registry - Product leaders from Lenny's Podcast
export const EXPERT_REGISTRY = {
  'Shreyas Doshi': {
    role: 'Product Strategy',
    emoji: '🎯',
    twitter: 'shreyas',
    color: '#A78BFA',
    gender: 'male'
  },
  'Lenny Rachitsky': {
    role: 'Growth & PMF',
    emoji: '🚀',
    twitter: 'lennysan',
    color: '#60A5FA',
    gender: 'male'
  },
  'Madhavan Ramanujam': {
    role: 'Pricing Expert',
    emoji: '💰',
    twitter: 'madhavan_r',
    color: '#FBBF24',
    gender: 'male'
  },
  'April Dunford': {
    role: 'Positioning Expert',
    emoji: '🎪',
    twitter: 'aprildunford',
    color: '#F472B6',
    gender: 'female'
  },
  'Marty Cagan': {
    role: 'Product Leadership',
    emoji: '📚',
    website: 'svpg.com',
    color: '#2DD4BF',
    gender: 'male'
  },
  'Gibson Biddle': {
    role: 'Product Strategy',
    emoji: '🎬',
    twitter: 'gibsonbiddle',
    color: '#FB923C',
    gender: 'male'
  },
  'Teresa Torres': {
    role: 'Discovery Coach',
    emoji: '🔬',
    twitter: 'ttorres',
    color: '#A3E635',
    gender: 'female'
  },
  'Ravi Mehta': {
    role: 'Product Leadership',
    emoji: '📊',
    twitter: 'rfrm',
    color: '#38BDF8',
    gender: 'male'
  },
  'Elena Verna': {
    role: 'Growth Expert',
    emoji: '📈',
    twitter: 'elenaverna',
    color: '#C084FC',
    gender: 'female'
  },
  'Julie Zhuo': {
    role: 'Design Leadership',
    emoji: '🎨',
    twitter: 'joulee',
    color: '#FB7185',
    gender: 'female'
  }
};

// Featured experts for display
export const FEATURED_EXPERTS = [
  'Shreyas Doshi',
  'Lenny Rachitsky', 
  'Madhavan Ramanujam',
  'April Dunford',
  'Marty Cagan'
];

// Pattern categories
export const CATEGORIES = {
  positioning: {
    label: 'Positioning',
    color: '#A78BFA',
    bgColor: 'rgba(139, 92, 246, 0.12)'
  },
  pricing: {
    label: 'Pricing',
    color: '#FBBF24',
    bgColor: 'rgba(251, 191, 36, 0.12)'
  },
  distribution: {
    label: 'Distribution',
    color: '#60A5FA',
    bgColor: 'rgba(96, 165, 250, 0.12)'
  },
  product: {
    label: 'Product',
    color: '#2DD4BF',
    bgColor: 'rgba(45, 212, 191, 0.12)'
  },
  conversion: {
    label: 'Conversion',
    color: '#F472B6',
    bgColor: 'rgba(244, 114, 182, 0.12)'
  },
  trust: {
    label: 'Trust',
    color: '#FB923C',
    bgColor: 'rgba(251, 146, 60, 0.12)'
  }
};

// Severity levels
export const SEVERITY = {
  high: {
    label: 'High Impact',
    color: '#F87171',
    bgColor: 'rgba(239, 68, 68, 0.12)',
    borderColor: 'rgba(239, 68, 68, 0.25)',
    gradient: 'linear-gradient(90deg, #EF4444 0%, #F87171 100%)'
  },
  medium: {
    label: 'Medium Impact',
    color: '#FBBF24',
    bgColor: 'rgba(251, 191, 36, 0.12)',
    borderColor: 'rgba(251, 191, 36, 0.25)',
    gradient: 'linear-gradient(90deg, #F59E0B 0%, #FBBF24 100%)'
  },
  low: {
    label: 'Low Impact',
    color: '#34D399',
    bgColor: 'rgba(52, 211, 153, 0.12)',
    borderColor: 'rgba(52, 211, 153, 0.25)',
    gradient: 'linear-gradient(90deg, #14B8A6 0%, #2DD4BF 100%)'
  }
};

// Timeframe urgency colors
export const TIMEFRAMES = {
  'This week': { color: '#14B8A6', urgent: true },
  'Next week': { color: '#71717A', urgent: false },
  'This month': { color: '#52525B', urgent: false }
};
